import { SubmissionEmailValidationState, submissionEmailValidationInitialState } from './store/State'
import {
  setEmail,
  setIsSubmitting,
  setIsValidEmail,
  setError,
  reset,
  SubmissionEmailValidationAction
} from './store/Actions'
import reducer from './store/Reducer'
import { EnterpriseRequests } from 'lib'
import SignInService from 'smart-components/sign-in/Service'
import ISubmissionLinkVerifiedEmailView from 'types/ISubmissionLinkVerifiedEmailView'
import ServiceProviderBase from 'lib/ServiceProviderBase'

export class SubmissionEmailValidationService extends ServiceProviderBase<
  SubmissionEmailValidationState,
  SubmissionEmailValidationAction
> {
  constructor() {
    super(submissionEmailValidationInitialState)
  }

  reduce(
    state: SubmissionEmailValidationState,
    action: SubmissionEmailValidationAction
  ): SubmissionEmailValidationState {
    return reducer(state, action)
  }

  setEmail(email: string) {
    this.dispatch(setEmail(email))
  }

  setIsValidEmail() {
    this.dispatch(setIsValidEmail(SignInService.isValidEmail(this.state.email)))
  }

  clearError() {
    this.dispatch(setError(null))
  }

  async validateSubmissionLink(
    enterpriseId: string,
    submissionLinkCode: string
  ): Promise<[ISubmissionLinkVerifiedEmailView, number, string]> {
    if (!enterpriseId || !submissionLinkCode) {
      const validationError = 'Invalid enterprise or submission link code'
      this.dispatch(setError(validationError))
      return [null, 400, validationError]
    }

    this.dispatch(setIsSubmitting(true))

    const [data, status, error] = await EnterpriseRequests.validateSubmissionLink(
      enterpriseId,
      submissionLinkCode,
      this.state.email
    )

    this.dispatch(setIsSubmitting(false))

    if (error) {
      if (status === 400) {
        this.dispatch(setError(error))
      }
      return [null, status, error]
    }

    return [data, 200, null]
  }

  reset() {
    this.dispatch(reset())
  }
}

let instance: SubmissionEmailValidationService

export default (() => {
  if (!instance) {
    instance = new SubmissionEmailValidationService()
  }
  return instance
})()
